import { Box, Button, LoadingOverlay, Table } from '@mantine/core';
import classes from './styles.module.css';
import { SectionTemplate } from '@/containers/pages/user/components/section-template';
import { DlpItem } from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/DlpItem';
import useDlpPage, {
  ItemDlpTypes
} from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/useDlpPage';
import EditDlpDialog from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/components/EditDlpDialog';
import MakeDlpDialog from '@/containers/pages/user/feature/edit-user/components/sections/DlpAntivirus/components/MakeDlpDialog';
import { themeColors } from '@/theme/colors';
import React from 'react';
import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const DlpAntivirus = () => {
  const { t } = useTranslation();
  const context = useDlpPage();

  const {
    isLoading,
    itemToEditId,
    itemControl,
    setItemControl,
    setItemToEditId,
    dlps,
    loadProfiles,
    onProfileSaved,
    toggleEnabled,
    profileToEdit
  } = context;

  const isEditOpen = Boolean(itemControl === ItemDlpTypes.EDIT && itemToEditId);
  const isMakeOpen = Boolean(itemControl === ItemDlpTypes.CREATE);
  const goToMakeDlp = () => setItemControl(ItemDlpTypes.CREATE);
  const closeModal = () => {
    setItemControl(ItemDlpTypes.NONE);
    setItemToEditId(null);
  };
  const editDlpAction = (id: number) => {
    setItemToEditId(id);
    setItemControl(ItemDlpTypes.EDIT);
  };

  return (
    <SectionTemplate title={t('dlp.title')}>
      <Box className={classes.container}>
        <LoadingOverlay visible={isLoading} />
      </Box>
      <Table maw={600}>
        <Table.Thead>
          <Table.Tr>
            <Table.Th style={{ width: '100%' }}>{t('dlp.connectionName')}</Table.Th>
            <Table.Th>{t('dlp.activity')}</Table.Th>
            <Table.Th style={{ width: 60, maxWidth: 60 }}></Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {dlps
            .filter((profile) => profile?.Id)
            .map((profile) => (
              <DlpItem
                key={profile.Id}
                profile={profile}
                onEdit={editDlpAction}
                onDelete={loadProfiles}
                onToggle={(enabled) => toggleEnabled(profile.Id, enabled)}
              />
            ))}
        </Table.Tbody>
      </Table>
      <Button
        className={classes.addButton}
        size="sm"
        mt="sm"
        color="#667085"
        variant="outline"
        rightSection={<IconPlus color={themeColors.brandGray[0]} />}
        onClick={goToMakeDlp}
      >
        {t('dlp.addIntegration')}
      </Button>
      {isEditOpen && (
        <EditDlpDialog
          isOpen={isEditOpen}
          onClose={closeModal}
          profile={profileToEdit}
          onSuccess={onProfileSaved}
        />
      )}
      {isMakeOpen && (
        <MakeDlpDialog isOpen={isMakeOpen} onClose={closeModal} onSuccess={onProfileSaved} />
      )}
    </SectionTemplate>
  );
};
